<div class="page-head">
  <div class="container-fluid-proj">
    <div class="page-title">
      <span class="headerName" [joyrideStep]="gtStep ? gtStep : 'ot-step'" [text]="gtText">{{
        headerData!.materialName
      }}</span>
    </div>
  </div>
</div>
